import React from 'react';
import propTypes from 'prop-types';

import { navBtnPropTypes } from './DetailPropTypes';

import FadingContainer from '../FadingContainer/FadingContainer';
import { createSkeletonItems } from '../Skeleton/SkeletonHelpers';

import './DetailNav.scss';

const DetailNav = ({
  navBtns,
  className,
}) => {
  const onClick = (section) => {
    const sectionDiv = document.getElementById(section);
    if (!sectionDiv) return;
    const headerHeight = document.querySelector('.modalHeader')?.offsetHeight;
    sectionDiv.style.scrollMarginTop = `${headerHeight}px`;
    sectionDiv.scrollIntoView({ behavior: 'smooth' });
  };

  // Don't render at all if we have 1 or fewer nav buttons
  // Show skeleton only if null (loading) AND we expect more than 1 button
  if (navBtns !== null && (!navBtns || navBtns.length <= 1)) {
    return null;
  }

  return (
    <FadingContainer>
      <div className={`detailNav ${className || ''}`}>

        { navBtns?.length > 1 && (
          navBtns.map((btn) => (
            <button
              className="detailNav__item content-fadeIn"
              type="button"
              key={btn.section}
              onClick={() => onClick(btn.section)}
            >
              {btn.text}
            </button>
          ))
        )}

        { createSkeletonItems('div', 'detailNav__item', 'small', 3, navBtns === null) }

      </div>
    </FadingContainer>
  );
};

DetailNav.propTypes = {
  navBtns: navBtnPropTypes,
  className: propTypes.string,
};

DetailNav.defaultProps = {
  navBtns: undefined, // stops skeleton from showing when no navbtns are passed in
  className: null,
};

export default DetailNav;
